import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { Link, useLocation, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import axiosInstance from "../../../../Services/axiosCommon";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DeleteIcon from "../../../../Components/Icons/Delete";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement, {
  videotype,
} from "../../../../Components/Utils/CustomAttrachmentupload";
import EditIcon from "../../../../Components/Icons/Edit";
import CloseIcon from "../../../../Components/Icons/Close";
import Video from "../../../../Components/Icons/Video";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

function EditFE() {
  const { value: status, getData: refstatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_FireExtinguisher"
  );
  const { data: contract } = UseDropDown(`/contract/drop-down`);
  const { data: user } = UseDropDown(`/user/new-drop-down`);

   const { data: client, setDataCustomer } = UseCustomerDropDownNew(
      "/clients/drop-down",
      // searchClient
    );
  
    const { value: Approved, getData: refApproved } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Approved_FireExtinguisher"
    );
  const [image, setImage] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  // const { value: Status, getData: refStatus } = useFetchMataData(
  //   `/dropdown/dropdown-details/`,
  //   "status_RFQ"
  // );
  // const { data: Purchaser } = UseDropDown("/user/purchaser/drop-down");
  // const { value: priorityRFQ } = useFetchMataData(
  //   `/dropdown/dropdown-details/`,
  //   "priority_RFQ"
  // );
  const [isEditQua, setIsEditQua] = useState(false);
  const { Oncancel, editFormData, contextHolder, isLoading } =
    useEditFormData();
  // const { data: vendors } = UseDropDown("/vendors/drop-down");
  // const { data: PR } = UseDropDown("/PR/drop-down");
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const { fireSuppressionEditId } = useParams();
  const location = useLocation();

  // const data = location.state?.data;

  const from = location.state?.from;

  const [dataa, setData] = useState(null);
  
 
  
  console.log("ccc", dataa);
  const [createNew, setCreateNew] = useState([]);

  function getView() {
    axiosInstance 
      .get(`/collection-and-returns/${fireSuppressionEditId}`)
      .then((res) => {
        res?.data?.data && setData(res?.data?.data);
 setCreateNew({
    // date: data.date,
    contractId: res?.data?.data?.contractId,
    type:2,
    deliveredOn: res?.data?.data?.deliveredOn,
    collectedOn: res?.data?.data?.collectedOn,
    collectors:res?.data?.data?.collectorIds,
       status:res?.data?.data?.status|| "",

    deliveredBy:res?.data?.data?.deliveredBy,
    approvedBy:res?.data?.data?.approvedBy,
    countryCode:res?.data?.data?.countryCode,
    phone:res?.data?.data?.phone,
    refNumber:res?.data?.data?.refNumber,



  });
  
})


.catch(err=>{
  console.log("err", err);
})
}
  const [error, setError] = useState("");
  console.log("create neewww",createNew);

  
  useEffect(() => {
    // if (!crData) {
      getView();
    // }
  }, []);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
         contractId: yup.string().required("ContractId is requred!"),
         clientId: yup.string().required("ClientId is requred!"),
   
       }),

    onSubmit: async (value, { resetForm }) => {
      // setLoading(true)
      // if (dataa.items.length === 0) {
      //   setError("Product table is empty");
      //   return;
      // }
      let formData = new FormData();

      const valueWithItems = {
        ...value,
        // items: dataa.items,
        filesToRemove: fileRemoveList,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
                   await editFormData({url:`/collection-and-returns/edit-cr/${fireSuppressionEditId}`,formData:formData,navigateUrl:from ||`/collectionAndreturn/fireSuppression`,resetForm:resetForm   })

      // editFormData(`/collection-and-returns/edit-cr/${fireSuppressionEditId}`, formData, resetForm, from);
    },
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const toast = useToast();

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  useEffect(() => {
    if (
      dataa?.attachments !== null &&
      dataa?.attachments !== "None" &&
      dataa?.attachments !== "[]"
    ) {
      console.log(dataa?.attachments, "ghjkllgd");
      setFilePathList(dataa?.attachments);

      setRemoveFilePathList(dataa?.attachments || []);
    }
  }, [dataa]);

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    let removeFile = filePathList.find((itemList) => itemList.file === item);
    console.log("llll", filterList);
    setFileRemoveList([...fileRemoveList, removeFile.file]);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }

  const [prlist, setPrlist] = useState([]);

  const getPr = (contractId) => {
    if (contractId !== "") {
      axiosInstance
        .get(`/contract/equipments/${contractId}`)
        .then((res) => {
          let data = res.data.data;
          setPrlist(data);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    if (formik.values.contractId) {
      getPr(formik.values.contractId);
    }
  }, [formik.values.contractId]);
  const [deletedItem, setDeletedItem] = useState([]);
  const [deletedItemDropDown, setDeletedItemDropDown] = useState([]);
  const handleDelete = (productId) => {
    const updateProducts = dataa?.items.filter(
      (item) => item.productId !== productId
    );
    console.log(updateProducts, "pp");
    setData((prevState) => ({
      ...prevState,
      items: updateProducts,
    }));
    const deletedItems = dataa?.items.filter(
      (item) => item.productId == productId
    );
    setDeletedItem((prevDeletedItems) => [
      ...prevDeletedItems,
      ...deletedItems,
    ]);
  };
  console.log("dl", deletedItem);
  useEffect(() => {
    let tempData = [];
    deletedItem.forEach((item) => {
      let tempObject = { value: item.productId, label: item.product_name };
      tempData.push(tempObject);
    });
    setDeletedItemDropDown(tempData);
  }, [deletedItem]);
  console.log("dele", deletedItemDropDown);

  const handleAdd = () => {
    const selectedProductId = formik.values.productId;

    // Find the selected product's details from the deletedItemDropDown (or deletedItem array)
    const selectedProduct = deletedItem.find(
      (item) => item.productId === selectedProductId
    );

    if (selectedProduct) {
      // Add the selected product to prList
      setData((prevState) => ({
        ...prevState,
        items: [...prevState.items, selectedProduct],
      }));

      // Optionally, remove the selected product from the dropdown after adding it to prList
      setDeletedItem((prevDeletedItems) =>
        prevDeletedItems.filter((item) => item.productId !== selectedProductId)
      );
    }
  };

  useEffect(() => {
    if (dataa?.items?.length > 0) {
      setError("");
    }
  }, [dataa?.items]);

  const [finalList, setFinalList] = useState(dataa?.items);

  const handleQuantityChange = (e, index) => {
    const updatedItems = [...finalList];
    updatedItems[index].quantity = e.target.value;
    setFinalList(updatedItems);
    console.log("shsd", finalList);
  };

 

  console.log("sss", dataa?.productList);

  const getCustomerRef = (id) => {
      if (id !== "") {
        axiosInstance
          .get(`/contract/${id}`)
          .then((res) => {
            let data = res.data.data;
            formik?.setFieldValue("clientId", data.clientId);
  
          })
          .catch((err) => {
            console.log(err, "err");
          });
      }
    };
  
    useEffect(() => {
      // if (formik.values.prId) {
      //   getPr(formik.values.prId);
      // }
      if (formik.values.contractId) {
        getCustomerRef(formik.values.contractId);
      }
    }, [formik.values.contractId]);

  return (
    <div className="w-full h-full py-2 px-4 ">
     
        <div className="flex justify-between w-full">
             <Breadcrumb
                    items={[
           
                      
                      {
                        name: "Fire Suppression",
                        link:"/collectionAndreturn/fireSuppression"
                       
                      },
          
                      { name: "Edit" },
                    ]}
                  /> 
          <BackButton />
        </div>
      
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
        <div className="w-full">
                                     <SettingHeading title={`Fire Suppression : ${createNew?.refNumber}` } />

              </div>
          <div className=" w-full h-full flex py-2 justify-start content-start flex-wrap  overflow-y-auto">
          <FormikSelectTwo
                label="Contract"
                Options={contract}
                formik={formik}
                placeholder="Choose"
                name="contractId"
                isRequired={true}
                zindex={11}
                disabled={true}
                width="w-full md:w-1/3 "
              />

{formik.values.contractId && (
  <FormikSelectTwo
    label="Client"
    placeholder="Client"
    Options={client}
    formik={formik}
    name="clientId"
    isRequired={true}
    width="w-full md:w-1/3"
    disabled={true}
  />
)}
               <NuDate
                             label="Collected Date"
                             formik={formik}
                             name="collectedOn"
                             width="w-full md:w-1/3"
                           />

                           
<MultiSelect
                // type="text"
                label="Collected By"
                placeholder="Collected By"
                Options={user}
                formik={formik}
                name="collectors"
                width="w-full md:w-1/2 lg:w-1/3"
              />

<FormikSelectTwo
              label="Approved By"
              placeholder="Choose"
              Options={user}
              formik={formik}
              name="approvedBy"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
              getFunc={refApproved}
              displayProperty={"Approved By"}
              propertyName={"Approved_FireExtinguisher"}
              FixPosition={true}
              PortalTarget={false}
            />

            <NuMobileNumber
                                           nunCode="countryCode"
                                           label="Phone"
                                           placeholder="Phone"
                                           formik={formik}
                                           name="phone"
                                           width="w-full md:w-1/2 lg:w-1/3"
                                         />

                            <NuDate
                             label="Return Date"
                             formik={formik}
                             name="deliveredOn"
                                     min={formik.values.collectedOn}

                             width="w-full md:w-1/3"
                           />

<FormikSelectTwo
                label="Delivered By"
                Options={user}
                formik={formik}
                placeholder="Delivered By"
                name="deliveredBy"
                // isRequired={true}
  
                width="w-full md:w-1/3"
              />
            {/* <NuInput
              label="Customer Reference"
              type="text"
              formik={formik}
              placeholder="Customer Reference"
              name="customerRfq"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            /> */}
             {/* <MultiSelect
                // type="text"
                label="RFQ Assignee"
                placeholder="RFQ Assignee"
                // Options={RFQAssignee}
                formik={formik}
                name="rfqAssignee"
                width="w-full md:w-1/2 lg:w-1/3"
              /> */}
             {/* <FormikSelectTwo
                type="text"
                label="Priority"
                placeholder="Choose"
                // disabled={true}
                Options={priorityRFQ}
                formik={formik}
                name="priority"
                width="w-full md:w-1/2 lg:w-1/3"
              /> */}
            {/* <FormikSelectTwo
              type="text"
              label="RFQ Type"
              placeholder="RFQ Type"
              Options={[
                { value: "local", label: "Local" },
                { value: "international", label: "International" },
              ]}
              formik={formik}
              disabled={true}
              name="rfqType"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
            /> */}
            {/* {data?.rfqType === "international" && (
              <FormikSelectTwo
                type="text"
                label="Supplier"
                placeholder="Choose"
                disabled={true}
                Options={vendors}
                formik={formik}
                name="vendor"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            )} */}
            {/* {data?.purchaser && (
              <FormikSelectTwo
                type="text"
                label="Local Purchaser"
                placeholder="Choose"
                Options={Purchaser}
                disabled={true}
                formik={formik}
                name="purchaser"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            )} */}
            {/* {data?.rfqType === "local" && data?.vendor && (
              <FormikSelectTwo
                type="text"
                label="Supplier"
                placeholder="Choose"
                disabled={true}
                Options={vendors}
                formik={formik}
                name="vendor"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            )} */}

            <DropDownAddMetaData
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
              getFunc={refstatus}
              displayProperty={"Status"}
              propertyName={"Status_FireExtinguisher"}
              FixPosition={false}
              PortalTarget={false}
            />

            {/* <NuTextArea
              label="Comments"
              type="text"
              formik={formik}
              placeholder="Comments"
              name="comments"
              width="w-full md:w-1/2 lg:w-1/3"
              new_width="w-full md:w-1/2 lg:w-2/3"

            /> */}
            <div className="w-full">
                                      <SettingHeading title="Attachments"  />

            </div>
            <div className="md:flex justify-between mt-5 px-3 w-full">
              <div className="w-full flex gap-2 items-center flex-wrap">
                {filePathList &&
                  filePathList?.map((imgs, idx) => {
                    console.log("img", imgs);
                    let Ext = imgs?.file_name.split(".").reverse()[0];
                    return (
                      <div
                        className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                        key={idx}
                        style={{
                          border: "1px solid gray",
                          borderColor:
                            "rgb(148 163 184 / var(--tw-bg-opacity))",
                        }}
                      >
                        <div
                          className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                          onClick={() => UpdateAttachmentList(imgs?.file)}
                        >
                          <CloseIcon color="white" height="8" width="8" />
                        </div>
                        <div
                          className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                          onClick={() => handleImageClick(imgs)}
                        >
                          <div className=" w-8 h-8">
                            {videotype.includes(Ext) ? <Video /> : null}

                            {Ext === ("docx" || "doc" || "txt") ? (
                              <Doc />
                            ) : Ext === ("xlsx" || "xls") ? (
                              <Xls />
                            ) : Ext === "txt" ? (
                              <Txt />
                            ) : Ext === "pdf" ? (
                              <Pdf />
                            ) : Ext === "pptx" ? (
                              <>No file</>
                            ) : (
                              <img src={imgs?.file} alt="#" width="120%" />
                            )}
                          </div>
                          <p className=" w-[50px] text-[11px] truncate">
                            {imgs?.file_name}
                          </p>
                        </div>
                      </div>
                    );
                  })}

                <Attachement
                  handleChange={handleImageChange}
                  preview={image || ""}
                  width="w-full md:w-1/2"
                  label="Attach"
                  multiple={true}
                  removeImages={removeImages}
                />
              </div>
            </div>
            <div className="w-full mx-auto my-4 mt-8 pb-2">
            <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel();
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
            {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div> */}
            {/* {deletedItemDropDown.length > 0 ? (
              <div className="w-full flex justify-start gap-2">
                <FormikSelectTwo
                  type="text"
                  label="Product"
                  placeholder="Product"
                  Options={deletedItemDropDown}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                />
                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
            ) : null} */}
            {/* <div className="w-full bg-white overflow-y-scroll mt-5">
              {error && (
                <p className="text-xs font-semibold text-red-500">{error}</p>
              )}
              <div className="w-full py-3 bg-textColor-main flex justify-between rounded-lg px-6">
                <p className="w-[5%]  text-left  text-white text-xs font-medium">
                  S.No{" "}
                </p>

                <p className="w-[10%] text-left text-white text-xs font-medium">
                Name
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Brand
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Model
                </p>
                <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                  Quantity
                  <span
                    className="pl-1 cursor-pointer"
                    onClick={() => {
                      setIsEditQua((prv) => !prv);
                    }}
                  >
                    {isEditQua === true && (
                      <EditIcon width={"14"} height={"14"} color="yellow" />
                    )}
                    {isEditQua === false && (
                      <EditIcon width={"14"} height={"14"} />
                    )}
                  </span>
                </p>
                <p className=" w-[5%] text-center text-white text-xs font-medium">
                  Action
                </p>
              </div>
              {dataa?.items?.length > 0 ? (
                <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                  {dataa?.items?.map((List, index) => (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-1">
                       {List?.sno||index + 1}
                      </p>{" "}
                      <p className="w-[10%] text-left  text-xs font-medium text-[#111537]">
                        {List?.name}
                      </p>
                      <p className="w-[10%] text-center  text-xs font-medium text-[#111537]">
                        {List?.brand}
                      </p>
                      <p className="w-[10%] text-center  text-xs font-medium text-[#111537]">
                        {List?.model}
                      </p>
                      <p className="w-[20%] text-center  text-xs font-medium text-[#111537]">
                        <input
                          type="number"
                          className="w-full outline-none text-center"
                          name="quantity"
                          formik={formik}
                          value={List?.quantity || ""}
                          disabled={!isEditQua}
                          onChange={(e) => handleQuantityChange(e, index)}
                        />
                      </p>
                      <div className="w-[5%] text-center">
                        <button
                          onClick={() => handleDelete(List?.productId)}
                          type="button"
                          className="text-red-500 cursor-pointer  ml-4 border-none"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full text-center text-[#93949f]">
                  No Items here
                </div>
              )}
            </div> */}

           
          </div>
        </div>
      </form>
    </div>
  );
}

export default EditFE;
